import React from "react";
import Upload from 'rc-upload';
import axios from 'axios'

export default class extends React.Component {


    constructor() {
        super();
        this.onStart = this.onStart.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onProgress = this.onProgress.bind(this);
        this.onError = this.onError.bind(this);
        this.removeFile = this.removeFile.bind(this);

        this.state = {
            status: "upload",
            files: []
        }

    }

    onStart(file) {
        this.setState({
            status: "uploading"
        })
    }

    onSuccess(res, file) {
        this.state.files.push(res[0]);
        this.setState({
            status: "uploaded"
        });


        this.updateFormData();

        this.props.onUploaded && this.props.onUploaded(res[0]);
    }

    onProgress({percent}, file) {
        console.log('onProgress', `${percent}%`, file.name);
    }

    onError(err) {
        this.setState({
            status: "error"
        });
    }

    customRequest(opinions) {
        const {
            action,
            file,
            onError,
            onProgress,
            onSuccess,
        } = opinions;

        const formData = new FormData();
        if(file.name.split(".").length<2){
            return
        }
        const filename = (new Date()).getTime() + "."+file.name.split(".").pop();
        formData.append('smartsheet/' + file.uid, file,filename);
        axios.post(action, formData, {
            withCredentials: true,
            headers: PlatformSDK.generateCsrfToken(),
            onUploadProgress: ({total, loaded}) => {
                onProgress({percent: Math.round(loaded / total * 100).toFixed(2)}, file);
            },
        }).then(({data: response}) => {
            onSuccess(response, file);
        }).catch(onError);

        return {
            abort() {
                console.log('upload progress is aborted.');
            },
        };
    }


    generateUploader(field, displayUploader) {
        const accept = field.parameters.filetype == "image" ? 'image/png, image/jpeg, .svg' : '*';
        const multiple = field.parameters.multiple == "true";
        const upload_url = PubHub.APIHost + '/v1/uploadfile/storage';
        return <Upload
            className={displayUploader ? "d-block" : "d-none"}
            accept={accept}
            multiple={multiple}
            headers={PlatformSDK.generateCsrfToken()}
            withCredentials={true}
            action={upload_url}
            onStart={this.onStart}
            onSuccess={this.onSuccess}
            onProgress={this.onProgress}
            onError={this.onError}
            customRequest={this.customRequest}>
            <button type="button" className="btn btn-secondary btn-lg cursor-pointer">
                <i className="fas fa-file-upload"></i> <span>{field.helpText}</span>
            </button>
        </Upload>
    }

    generateFileList(field, files) {

        let filelist = null;

        if (field.parameters.filetype && field.parameters.filetype == "image") {
            filelist = files.map((file, index) => {
                return <li className="pubhub-smartsheet-uploader-list-item-image"
                           key={index}>
                    <img src={file.linkUrl} alt=""/>
                    <i className="fal fa-minus-circle align-right cursor-pointer" onClick={this.removeFile}
                       data-index={index}></i>
                </li>
            });

            return <ul className="list-group pubhub-smartsheet-uploader-list-image">{filelist}</ul>

        }

        filelist = files.map((file, index) => {
            return <li className="list-group-item pubhub-smartsheet-uploader-list-item inner-addon right-addon"
                       key={index}>
                <span className="text">{file.fileName}</span>
                <i className="fal fa-minus-circle align-right cursor-pointer" onClick={this.removeFile}
                   data-index={index}></i>
            </li>
        });

        return <ul className="list-group">{filelist}</ul>



    }

    removeFile(event) {
        const fileIndex = parseInt(event.target.getAttribute("data-index"));
        this.state.files.splice(fileIndex, 1);

        this.setState({
            files: this.state.files,
            status: this.state.files.length ? "uploaded" : "upload"
        });

        this.updateFormData();


    }


    updateFormData() {
        const {field, config, formData} = this.props;
        const {status, files} = this.state;

        formData[field.name] = files.map(item => item.linkUrl).join("|");

        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    render() {
        const {field, config, formData ,id} = this.props;
        const {status, files} = this.state;

        let title = field.title;
        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }

        let content = null;
        let displayUploader = false;
        if (status == "upload") {
            displayUploader = true
        }

        if (status == "uploading") {
            content = <span className="pubhub-loading"></span>
        }

        if (status == "uploaded") {
            content = this.generateFileList(field, files)
        }

        const uploader = this.generateUploader(field, displayUploader);

        return (
            <div className="row pubhub-smartsheet-form-element pubhub-smartsheet-uploader" key={field.id}>
                <div className="pubhub-smartsheet-label">
                    <label htmlFor={field.id} className="col-form-label">{title}</label>
                </div>
                <div className="pubhub-smartsheet-element" key={id}>
                    {content}
                    {uploader}
                </div>
            </div>

        )
    }
}
